import { Box, Divider } from "@chakra-ui/react";
import { Flex, Heading } from "@chakra-ui/react";
import { TableListTitleProps } from "./interface";
import React from "react";

const TableListTitle: React.FC<TableListTitleProps> = ({
  title,
  subtitleComponent,
  actionComponents,
}) => {
  return (
    <>
      <Flex justifyContent="space-between">
        <Box>
          <Flex alignItems="center" gap="10px">
            <Heading mb="0" fontSize="20px" lineHeight={1}>
              {title}
            </Heading>
          </Flex>
          {subtitleComponent}
        </Box>
        <Box>{actionComponents}</Box>
      </Flex>

      <Divider />
    </>
  );
};

export default TableListTitle;
